module.exports = __webpack_public_path__ + "static/media/girl.6903abe4.png";